<template>
    <div class="third service-score-basicpage">
	    <div class="third-rea">
            <div class="third-btn">
                <div class="btn-left">检索条件</div>
                <div class="btn-right">
                    <el-button class="btn-two" type="primary" @click="searchHeader">查询</el-button>
                    <el-button class="btn-two" type="default" @click="reset">重置</el-button>
                    <span class="btn-shu"></span>
                    <el-button class="btn-four" type="default" icon="el-icon-search" @click="hignSearch">高级检索</el-button>
                </div>
            </div>
            <div class="third-search">
                <el-form :inline="true" :model="searchForm" label-width="76px">
                    <div class="search-row">
                        <div class="row-item">
                            <el-form-item label="服务名称">
                                <el-input
                                    class="item-input"
                                    :maxlength="30"
                                    v-model.trim="searchForm.serviceName"
                                    placeholder="请输入"
                                    @keyup.enter.native="searchHeader">
                                </el-input>
                            </el-form-item>
                        </div>
                        <!-- <div class="row-item">
                            <el-form-item label="服务场景">
                                <key-value-select
                                    :isNeedAll="true"
                                    className="item-input"
                                    v-model.trim="searchForm.serviceSceneId"
                                    placeholder="请选择"
                                    dictUrl="/api/blade-platform/baseService/getServiceScene"
                                    :dictProp="{
                                        data: 'result',
                                        label: 'name',
                                        value: 'id'
                                    }"
                                ></key-value-select>
                            </el-form-item>
                        </div>
                        <div class="row-item">
                            <el-form-item label="服务类型">
                                <key-value-select
                                    :isNeedAll="true"
                                    className="item-input"
                                    v-model.trim="searchForm.serviceTypeId"
                                    placeholder="请选择"
                                    dictUrl="/api/blade-platform/baseService/getServiceType"
                                    :dictProp="{
                                        data: 'result',
                                        label: 'name',
                                        value: 'id'
                                    }"
                                ></key-value-select>
                            </el-form-item>
                        </div> -->
                    </div>
                </el-form>
            </div>
		</div>
		<div class="third-one">
            <div class="third-do-btn">
                <div class="do-btn-right">
                    <div class="do-btn-check">
                        <el-checkbox class="btn-check-item" v-model="checked" @change="changeHign"></el-checkbox>
                        <span class="btn-check-span">显示高级功能</span>
                    </div>
                    <div class="do-btn-hign-list" v-if="checked">
                        <sort-data
                            :tableRow="tableRow"
                            @showList="getTableList"
                            sessionOriginalName="otherSortOrignalData_serviceScoreBasicpage"
                            sessionResultName="otherSortData_serviceScoreBasicpage"
                        ></sort-data>
                        <display-field
                            :selectList="tableRow"
                            sessionOriginalName="otherDisplayFiedOrignal_serviceScoreBasicpage"
                            @setDataOrder="getDataOrder"
                            sessionResultName="otherDisplayFied_serviceScoreBasicpage"
                        ></display-field>
                        <span class="btn-check-span" style="color:#aeaeb4;">1颗星代表1分</span>
                    </div>
                </div>
                <div class="do-btn-right-right">
                    <span class="btn-check-span" v-if="scoreType == '1'">自动计算</span>
                    <span class="btn-check-span" v-if="scoreType == '2'">最低分制</span>

                    <el-button style="height: 24px;" type="default" icon="el-icon-s-tools" @click="openSetScoreMechanismModal">设置评分机制</el-button>
                </div>
            </div>
            <div>
                <el-table
                    class="third-tableThree"
                    :data="tableData"
                    border
                    stripe
                    v-loading="tableLoading"
                    ref="otherTableBasic"
                    row-key="otherUserId">
                    <template v-for="(val,key) in tableDataShow">
                        <el-table-column
                            v-if="val.needKeyValue"
                            min-width="100px"
                            :prop="val.key"
                            :label="val.column"
                            :key="key"
                            :show-overflow-tooltip="true">
                            <template slot-scope="scope">
                                <span style="color:red;" v-if="scope.row.status == 0">已下架</span>
                                <span style="color:#33CC99" v-if="scope.row.status == 1">已上架</span>
                            </template>
                        </el-table-column>
                        <el-table-column
                            v-else
                            min-width="100px"
                            :prop="val.key"
                            :label="val.column"
                            :key="key"
                            :show-overflow-tooltip="true">
                        </el-table-column>
                    </template>
                    <el-table-column label="操作">
                        <template slot-scope="{row}">
                            <el-button @click="jumpToDetail(row)" type="text" size="small">评分列表</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <div class="third-page">
                    <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="currentPage"
                        background
                        :page-sizes="[10, 20, 30, 40]"
                        :page-size="pageSize"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="total">
                    </el-pagination>
                </div>
            </div>
		</div>

		<new-notice-modal
			:noticeModalVisible="noticeModal"
			:noticeTitle="noticeTitle"
			:noticeType="noticeType"
			:noticeContent="noitceContent">
			<template v-slot:footer>
				<el-button class="modal-footer-two" @click="cancel">取消</el-button>
				<el-button class="modal-footer-two" type="primary" @click="confirm">确定</el-button>
			</template>
		</new-notice-modal>

		<hign-modal
			:hignModalVisible="hignModal"
			@searchModal="toHignSearch"
			@cancelModal="closeModal"
			:hignOneList="tableRow">
		</hign-modal>

        <el-dialog
            title="设置评分机制"
            :visible.sync="setScoreMechanismModal"
            width="579px"
            v-el-drag-dialog
            :before-close="handleClose"
            :close-on-click-modal="false">
            <div>
                <el-form :model="scoreForm" :rules="scoreFormRules" ref="scoreForm" label-width="140px" class="demo-ruleForm" @validate="validateTwo" :show-message="false">
                    <el-form-item label="评分机制" prop="scoreType">
                        <el-radio-group v-model="scoreForm.scoreType">
                            <el-radio :label="1">自动计算</el-radio>
                            <el-radio :label="2">最低分制</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <template v-if="scoreForm.scoreType == 1">
                        <el-form-item label="" >
                             <span style="font-size:12px;color:#909399;">系统自动根据用户评分计算服务平均分</span>
                        </el-form-item>
                    </template>
                    <div v-if="scoreForm.scoreType == 2">
                        <el-form-item label="最低分" prop="lowestScore">
                            <el-input class="list-input" :maxlength="3" placeholder="请输入0-5的数字，最多包含1位小数" v-model="scoreForm.lowestScore" style="width:200px;"></el-input><span style="margin-left:5px;">分</span>
                        </el-form-item>
                        <el-form-item label="低于最低分显示分数" prop="lowestShowScore">
                            <el-input class="list-input" :maxlength="3" placeholder="请输入0-5的数字，最多包含1位小数" v-model="scoreForm.lowestShowScore" style="width:200px;"></el-input><span style="margin-left:5px;">分</span>
                        </el-form-item>
                    </div>
                </el-form>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="handleClose">取 消</el-button>
                <el-button type="primary" @click="setScoreMechanismModalBefore">保 存</el-button>
            </span>
        </el-dialog>

	</div>
</template>

<script>
import { mapActions, mapMutations, mapState } from "vuex";
import { removeStore, setStore, getStore } from "@/utils/store";
import { cloneDeep } from "lodash";
export default {
	name: "BasicPage",
	data() {
        var checkScore = (rule, value, callback) => {
            var regName = /^[0-5]+([.]{1}[0-9]{1})?$/
            if (!regName.test(value)) {
                callback(new Error('请输入0-5的数字，最多包含1位小数'));
            } else if (value > 5) {
                callback(new Error('请输入0-5的数字，最多包含1位小数'));
            } else {
                callback();
            }
        };
		return {
            tableLoading: false,
            pageSize: 40,
            currentPage: 1,
            total: 0,
            tableData: [],
            hignModal: false, // 高级搜索
            searchForm: {
                serviceName: '', // 名称
                serviceSceneId: '', // 场景
                serviceTypeId: '', // 类型
            },
            checked: true,
            noticeModal: false, // 提示弹窗
            noticeType: 1, // 提示类型
            noitceContent: "是否确认删除？", // 提示信息
            noticeTitle: "确认操作", // 提示
            deleteWay: 'singel',
            deleteRow: {}, // 单个删除行
            deleteList: [], // 多行删除
            keyIdList: [],
            type: "single",
            orderConfig: '', // 顺序设置
            tableDataShow: [], // 表格行设置
            hignSearchRes: '', // 高级检索条件
            tableRow: [
                {
                    column: "服务名称",
                    key: "serviceName",
                    needKeyValue: false,
                    caseKey: "service_name"
                },
                {
                    column: "评分人数",
                    key: "count",
                    needKeyValue: false,
                    caseKey: "count"
                },
                {
                    column: "评分方式",
                    key: "serviceCount",
                    needKeyValue: false,
                    caseKey: "service_count"
                },
                {
                    column: "自动计算平均分",
                    key: "serviceAvg",
                    needKeyValue: false,
                    caseKey: "service_avg"
                },
                {
                    column: "服务创建时间",
                    key: "createTime",
                    needKeyValue: false,
                    caseKey: "create_time"
                },
                {
                    column: "最新评分时间",
                    key: "newTime",
                    needKeyValue: false,
                    caseKey: "new_time"
                },
                {
                    column: "服务状态",
                    key: "status",
                    needKeyValue: true,
                    caseKey: "status",
                    isCustomList: [
                        {
                        label: '已上架',
                        value: '1'
                        },
                        {
                        label: '已下架',
                        value: '0'
                        }
                    ]
                },
            ],
            scoreForm: {
                id: '',
                scoreType: 1,
                lowestScore: '',
                lowestShowScore: '',
                createTime: '',
                updateTime: '',
            },
            scoreFormRules: {
                scoreType: [
                    { required: true, message: '请选择评分机制', trigger: 'change' }
                ],
                lowestScore: [
                    { required: true, message: '请输入最低分', trigger: 'blur' },
                    { validator: checkScore, trigger: 'blur' }
                ],
                lowestShowScore: [
                    { required: true, message: '请输入低于最低分显示分数', trigger: 'blur' },
                    { validator: checkScore, trigger: 'blur' }
                ],
            },
            confirmCancelShieldModal: false,
            typeLists: [],
            sceneList: [],
            scoreMechanismConfig: '',
            countNum: 1, // 只显示第一条错误信息
            setScoreMechanismModal: false,
            scoreType: 1,
		};
	},
	created() {
		const dispField = this.getSessonValue("otherDisplayFied");
		const tableRow = this.getSessonValue("otherSortData");
		if (dispField) {
		    this.orderConfig = dispField;
		}
		if (tableRow) {
		    this.tableDataShow = tableRow;
		} else {
		    this.tableDataShow = this.tableRow;
        }

    },
    mounted () {
        this.getScoreMechanismDetail()
        this.search();
    },
	computed: {
		...mapState({
		//   tableRow: state => state.power.selectConfig.eduOtherUserInfo,
		  userInfo: state => state.user.userInfo
		})
	},
	methods: {
        ...mapMutations({
            changeComponentName: "SET_serviceScoreComponentName"
        }),
        ...mapActions([
            'scoreMechanismDetail',
            'serviceScoreCountList',
            'updateScoreMechanism',
        ]),
        toUserPage(val) {
            console.log(val)
            setStore({
                name: "rowDataTo_userDynamic_InSensitiveWord",
                content: val,
                type: "session"
            });
            this.changeComponentName("userManageDetails");
        },
        async getScoreMechanismDetail() {
            const {
                data: { result, msg, status }
            } = await this.scoreMechanismDetail()
            this.tableLoading = false
            if (status === 1000) {
                console.log(result)
                this.scoreMechanismConfig = result

                this.scoreForm.id = this.scoreMechanismConfig.id
                this.scoreForm.scoreType = this.scoreMechanismConfig.scoreType
                this.scoreForm.lowestScore = this.scoreMechanismConfig.lowestScore
                this.scoreForm.lowestShowScore = this.scoreMechanismConfig.lowestShowScore
                this.scoreForm.createTime = this.scoreMechanismConfig.createTime
                this.scoreForm.updateTime = this.scoreMechanismConfig.updateTime
                this.scoreType = this.scoreForm.scoreType
                return
            }
            this.$message.error(msg);
        },
		openSetScoreMechanismModal() {
            this.getScoreMechanismDetail()
            this.setScoreMechanismModal = true
		},
		// 高级检索
		async toHignSearch(res) {
            this.currentPage = 1;
            this.hignSearchRes = res;
            this.hignModal = false;
            this.tableLoading = true
            this.searchForm.serviceName = this.searchForm.serviceName.trim()
            let params = [
                {
                    current: this.currentPage,
                    size: this.pageSize,
                },
                {
                    serviceName: this.searchForm.serviceName,
                    serviceSceneId: this.searchForm.serviceSceneId,
                    serviceTypeId: this.searchForm.serviceTypeId,
                    advancedSearch: this.hignSearchRes,
                    dataSortStr: this.orderConfig,
                }
            ]
            const {
                data: { result, msg, status }
            } = await this.serviceScoreCountList(params)
            this.tableLoading = false
            if (status === 1000) {
                console.log(result)
                this.tableData = result.records
                this.total = Number(result.total)
                return
            }
            this.$message.error(msg);
		},
		add() {
		    this.$emit("changeComponent", "DetailsInfo");
		},
		getDataOrder(value) {
            this.orderConfig = value;
            this.search();
		},
		getTableList(value) {
		    this.tableDataShow = value;
		},
		async eduotheruserinfoRemove(params) {
            this.noticeModal = false;
            const {
                data: { msg, status }
            } = await eduotheruserinfoRemovePort(params);
            if (status === 1000) {
                this.$message.success("删除成功");
                this.$refs.otherTableBasic.clearSelection();
                if (this.typ === "single") {
                    this.deleteRow = null;
                } else {
                    this.deleteList = [];
                    this.keyIdList = [];
                }
                return this.search();
            }
            this.$message.error(msg);
            return {};
		},
		cancel() {
            if (this.type === "single") {
                this.deleteRow = null;
            }
            this.noticeModal = false;
		},
		confirm() {
            if (this.type === "single") {
                console.log(this.deleteRow);
                return this.eduotheruserinfoRemove({
                    ids: this.deleteRow.otherUserId,
                    keyIds: this.deleteRow.keyId,
                    tenantId: this.userInfo.tenant_id
                });
            }
            console.log("当前删除列表", this.deleteList);
            return this.eduotheruserinfoRemove({
                ids: this.deleteList.join(","),
                keyId: this.keyIdList.join(","),
                tenantId: this.userInfo.tenant_id
            });
		},
		reset() {
            Object.assign(this.searchForm, this.$options.data().searchForm);
            this.hignSearchRes = ''
            this.search();
        },
        searchHeader() {
            this.currentPage = 1;
            this.search();
        },
		async search() {
            this.tableLoading = true
            this.searchForm.serviceName = this.searchForm.serviceName.trim()
            let params = [
                {
                    current: this.currentPage,
                    size: this.pageSize,
                },
                {
                    serviceName: this.searchForm.serviceName,
                    serviceSceneId: this.searchForm.serviceSceneId,
                    serviceTypeId: this.searchForm.serviceTypeId,
                    advancedSearch: this.hignSearchRes,
                    dataSortStr: this.orderConfig,
                }
            ]
            const {
                data: { result, msg, status }
            } = await this.serviceScoreCountList(params)
            this.tableLoading = false
            if (status === 1000) {
                console.log(result)
                this.tableData = result.records
                this.total = Number(result.total)
                return
            }
            this.$message.error(msg);
		},
		jumpToDetail(rowData) {
            setStore({
                name: "rowDataTo_ScoreList",
                content: rowData,
                type: "session"
            });
            this.changeComponentName("ScoreList");
        },
        // 验证
        validateTwo(prop, msgStatus, validateMessage) {
            // console.log(prop, msgStatus, validateMessage)
            if (!msgStatus && !this.countNum) {
                this.countNum += 1;
                if (validateMessage) {
                    this.$message.error(validateMessage)
                }
            }
        },
        setScoreMechanismModalBefore() {
            this.countNum = 0;
            // this.addNewTypeModal = false;
            this.$refs['scoreForm'].validate((valid) => {
                console.log(valid)
                if (valid) {
                    this.sureSetScoreMechanismModal()
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },
        async sureSetScoreMechanismModal() {
            const {
                data: { msg, status }
            } = await this.updateScoreMechanism({
                id: this.scoreForm.id,
                scoreType: this.scoreForm.scoreType,
                lowestScore: this.scoreForm.lowestScore,
                lowestShowScore: this.scoreForm.lowestShowScore,
                createTime: this.scoreForm.createTime,
                updateTime: this.scoreForm.updateTime,
            })
            this.tableLoading = false
            if (status === 1000) {
                this.scoreType = this.scoreForm.scoreType
                this.$message.success('操作成功！')
                this.handleClose()
                this.search()
                return
            }
            this.$message.error(msg);
        },
		// 关闭弹窗
		handleClose() {
            this.$refs['scoreForm'].resetFields();
            this.setScoreMechanismModal = false;
            this.scoreForm.id = ''
            this.scoreForm.scoreType = ''
            this.scoreForm.lowestScore = ''
            this.scoreForm.lowestShowScore = ''
            this.scoreForm.createTime = ''
            this.scoreForm.updateTime = ''
		},
		// 保存字段
		addFields() {
		    console.log(111);
		},
		// 显示高级或者不显示
		changeHign() {
		    console.log(this.checked);
		},
		// 关闭弹窗
		closeModal() {
		    this.hignModal = false;
		},
		// 高级检索
		hignSearch() {
		    this.hignModal = true;
        },
        getSessonValue(name) {
            return getStore({
                name: name,
                type: "session"
            });
        },
        //条数变化
        handleSizeChange(val) {
            this.currentPage = 1;
            this.pageSize = val;
            this.search();
        },
        //页码变化
        handleCurrentChange(val) {
            this.currentPage = val;
            this.search();
        },
	}
};
</script>
<style lang="scss">
.service-score-basicpage {
	.third-tableThree {
		.el-table__body-wrapper {
			height: calc(100vh - 193px) !important;
		}
	}
    .el-form-item__label {
        margin-right: 10px;
    }
}
</style>
